import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { useContent } from '../../contexts/ContentContext';
import './Hero.css';

const Hero: React.FC = () => {
  const { language } = useLanguage();
  const { content, isLoading } = useContent();

  if (isLoading || !content) return null;

  const heroContent = content.hero[language];

  return (
    <section id="home" className="hero">
      <div className="hero-container">
        <div className="hero-left">
          <div className="profile-image">
            <img src="/face.jpg" alt="Hiroto Osaka" />
          </div>
          <h1 className="profile-name">{heroContent.name}</h1>
          <p className="profile-role">{heroContent.role}</p>
          <p className="profile-affiliation">{heroContent.affiliation}</p>
          
          <div className="social-links">
            {content.hero.socialLinks.map((link) => (
              <a
                key={link.id}
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={link.label}
              >
                <img src={link.icon} alt={link.label} />
              </a>
            ))}
          </div>
        </div>

        <div className="hero-right">
          <div className="about-section">
            <h2>{heroContent.aboutTitle}</h2>
            <div
              className="about-description"
              dangerouslySetInnerHTML={{ __html: heroContent.aboutDescriptionHtml }}
            />
          </div>

          <div className="info-sections">
            <div className="interests-section">
              <h3>{heroContent.interestsTitle}</h3>
              <ul>
                {heroContent.interests.map((interest, index) => (
                  <li key={index}>{interest}</li>
                ))}
              </ul>
            </div>

            <div className="education-section">
              <h3>{heroContent.educationTitle}</h3>
              <div className="education-timeline">
                {heroContent.education.map((edu, index) => (
                  <div key={index} className="education-item">
                    <div className="timeline-marker"></div>
                    <div className="education-content">
                      <p className="education-degree">{edu.degree}</p>
                      <p className="education-school">{edu.school}</p>
                      {edu.lab && <p className="education-lab">{edu.lab}</p>}
                      <p className="education-period">{edu.period}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero; 